import React from 'react';

const InfoIcons = ({ infoIconsList }) => {
  return (
    <section className="index-info-icons container-block">
      <h2 className="index-info-icons-heading">
        Flight Schools, Flying Clubs, Pilots and Student Pilots may:
      </h2>
      <div className="index-info-icons_item js--index-info-icons-items">
        {infoIconsList.map((el, index) => (
            <figure className="index-info-figure" key={index}>
              <img src={el.ico} className={el.name} alt={el.alt} title={el.title} height="84px" width="84px" />
              <figcaption className="index-info-text" children={el.title} />
            </figure>
          ))}
      </div>
    </section>
  );
};

export default InfoIcons;
